import { Box, Typography } from '@mui/material';

/**
 * Dato de una tarjeta mobile: etiqueta en `caption` y valor debajo.
 * @param {Object} props
 * @param {string} props.label Etiqueta del dato.
 * @param {React.ReactNode} props.children Valor.
 * @returns {JSX.Element}
 */
const InternalOrderMobileField = ({ label, children }) => (
  <Box sx={{ mb: 1 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    {children}
  </Box>
);

export default InternalOrderMobileField;
